import React from 'react'

function Templete3() {
  return (
    <div>Templete3</div>
  )
}

export default Templete3